import { CalendarIcon } from 'apps/app/src/components/icons/CalendarIcon';
import cn from 'classnames';
import React, { useMemo } from 'react';
import DatePicker from '../../../../../components/design/date-picker/DatePicker';
import { ArrowIcon } from '../../../../../components/icons/ArrowIcon';
import { ARROW_ICON_DIRECTIONS } from '../../../../../components/icons/ArrowIcon/types/arrow-icon-direction';
import { formatDate } from '../../../../../utils/date';

type ContractDatePickerProps = {  
  onSelect: (date: Date | undefined) => void;  
  date: Date | undefined;
  withoutArrow?:boolean;
  containerClassName?:string;
  fullWidth?:boolean;
};

export const ContractDatePicker: React.FC<ContractDatePickerProps> = ({ onSelect, date, withoutArrow, containerClassName, fullWidth }) => {
  const formattedDate = useMemo(() => {
    return date ? formatDate(date) : '';
  }, [date]);

  return (
    <DatePicker {...{ date, onSelect, containerClassName }} >
      <div className={cn(
        'border-line rounded-2lg bg-input flex h-16 items-center justify-between border px-8 py-4',
        { 'w-full' : fullWidth },
        { 'w-[312px]': !fullWidth },
      )}
      >         
        <div className="flex items-center">
          <CalendarIcon/>
          <span className='text-filled-text ml-2'>Start Day</span>
        </div>
        <span className="flex items-center space-x-2">
          <span className="text-style min-h-6 font-medium">{formattedDate}</span>
          {!withoutArrow && (
            <ArrowIcon
              className='text-style'
              direction={ARROW_ICON_DIRECTIONS.DOWN}
            />
          )}
        </span>
      </div>
    </DatePicker>
  );
};